import { FC } from 'react'
import styled from 'styled-components'
import Skeleton from '@app.components/Skeleton'
import WriterInfo from './components/WriterInfo'

interface IFNewsEditorLoadingProps {
  className?: string
}

const NewsEditorLoading: FC<IFNewsEditorLoadingProps> = ({ className }) => {
  return (
    <StyledWrapper className={className}>
      <WriterInfo isLoading />
      <div className="content-wrapper">
        <Skeleton width={150} height={13} />
        <Skeleton width={100} height={13} />
        <Skeleton width={80} height={13} />
      </div>
      <div className="button-wrapper">
        <Skeleton width={87} height={46} />
        <Skeleton width={110} height={46} />
      </div>
    </StyledWrapper>
  )
}

export default NewsEditorLoading

const StyledWrapper = styled.div`
  .content-wrapper {
    margin-top: 12px;
    display: grid;
    gap: 8px;
  }

  .button-wrapper {
    display: flex;
    gap: 10px;
    margin-top: 72px;
  }
`
